// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"ff7fa59d","240":"3ee50037","258":"e985d071","270":"ff1c3bde","295":"1f537d04","455":"b4b7e260","553":"b3cf857c"}[chunkId] + ".chunk.js";
};